// extracted by mini-css-extract-plugin
export default {"iframeContainer":"Frame-iframeContainer-159f239baba9490f5ea0d34016b21972","expand":"Frame-expand-dcc65a13a2a0965741ee2daaa501e88c"};